export default {
  agreementDefaults: [],
  agreementDefault: undefined,
};
